import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h5", { class: "fw-bold text-black mb-3" }, "Transporte escolar", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-uses-transport"
}, " ¿Usa transporte escolar? ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-pickup-name"
}, "Nombre de la persona que recoge / Empresa", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  class: "form-label fw-medium text-black",
  for: "input-pickup-phone"
}, "Teléfono de la persona que recoge / Empresa", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_radio_group = _resolveComponent("b-form-radio-group")!
  const _component_b_form_group = _resolveComponent("b-form-group")!
  const _component_b_col = _resolveComponent("b-col")!
  const _component_b_row = _resolveComponent("b-row")!
  const _component_b_form_input = _resolveComponent("b-form-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_b_form_radio_group, {
                  id: "input-uses-transport",
                  size: "sm",
                  modelValue: _ctx.recordProxy.UsesSchoolTransport,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = val => _ctx.updateField('UsesSchoolTransport', val)),
                  options: [
              { text: 'Sí', value: true },
              { text: 'No', value: false }
            ],
                  buttons: "",
                  "button-variant": "outline-success",
                  class: "d-flex gap-2 transport-radio"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_b_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_3,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-pickup-name",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.TransportationPickupPersonName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = val => _ctx.updateField('TransportationPickupPersonName', val)),
                    placeholder: "Ingrese el nombre",
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_b_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_b_form_group, null, {
              default: _withCtx(() => [
                _hoisted_4,
                _createElementVNode("div", null, [
                  _createVNode(_component_b_form_input, {
                    id: "input-pickup-phone",
                    class: "form-control fs-14 text-black shadow-none form-control-sm",
                    modelValue: _ctx.recordProxy.TransportationPickupPhone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = val => _ctx.updateField('TransportationPickupPhone', val)),
                    placeholder: "Ingrese el teléfono",
                    type: "text"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}